@for (row of strings; track row) {
  <div class="string-row" [ngClass]="rowClass">{{ row }}</div>
}
